import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { getApiErrorMessage } from "@/lib/utils_pharma";
import { toast } from "sonner";

export default function CategorySelect({ value, onChange, placeholder = "Select category", testId }) {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let active = true;
        const loadCategories = async () => {
            setLoading(true);
            try {
                const { data } = await api.get("/categories");
                if (active) setCategories(data || []);
            } catch (err) {
                toast.error(getApiErrorMessage(err, "Failed to load categories"));
            } finally {
                if (active) setLoading(false);
            }
        };
        loadCategories();
        return () => {
            active = false;
        };
    }, []);

    const normalizedValue = value || "";
    const hasCurrentValue = normalizedValue && !categories.some((c) => c.name === normalizedValue);

    return (
        <select
            data-testid={testId}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            value={normalizedValue}
            onChange={(e) => onChange(e.target.value)}
            disabled={loading}
        >
            <option value="">{loading ? "Loading categories…" : placeholder}</option>
            {hasCurrentValue && <option value={normalizedValue}>{normalizedValue}</option>}
            {categories.map((category) => (
                <option key={category.id} value={category.name}>{category.name}</option>
            ))}
        </select>
    );
}
